import {AuditLogsSortBy} from "@/api";
import {useCallback, useEffect, useState} from "react";

// Some utility types and functions to preserve compatibility with current sorting schema
type TimestampOrdering = "timestamp" | "~timestamp";

const ORDERING_MAP: {[K in TimestampOrdering]: AuditLogsSortBy} = {
    timestamp: AuditLogsSortBy.TimestampAsc,
    "~timestamp": AuditLogsSortBy.TimestampDesc,
} as const;

const timestampOrderingToAuditLogsSortBy = (order: TimestampOrdering[]): AuditLogsSortBy[] => {
    return order.map((o) => ORDERING_MAP[o]);
};

export function useSortingWithCompatibility(initialOrder: TimestampOrdering[]) {
    const [order, setOrder] = useState<AuditLogsSortBy[]>(timestampOrderingToAuditLogsSortBy(initialOrder));
    const [genericOrder, setGenericOrder] = useState<TimestampOrdering[]>(initialOrder);

    useEffect(() => {
        setOrder(timestampOrderingToAuditLogsSortBy(genericOrder));
    }, [genericOrder]);

    const setGenericOrderWithoutNeutral = useCallback((newOrder: string[]) => {
        if (newOrder.length === 0) {
            setGenericOrder(["timestamp"]);
        } else {
            setGenericOrder(newOrder as TimestampOrdering[]);
        }
    }, []);

    return {gqlOrder: order, order: genericOrder, setOrder: setGenericOrderWithoutNeutral};
}
